import { Component, Input } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { AppState } from '@shared/redux/config-store-state.model';
import { emitAlert, updateUser } from '@shared/redux/actions/actions-store-state.model';
import { ProfileApiService } from '@modules/profile/profile-api.service';
import { DataOption, Country, getDataCountries, getDataProvinces } from '@shared/data-structure/profile-data';

@Component({
    selector: 'astrea-profile-residence',
    templateUrl: './profile-residence.component.html',
    styleUrls: ['../profile-personal/profile-personal.component.scss'],
    standalone: false
})
export class ProfileResidenceComponent {

  public user: any;
  @Input() isUserShared!: boolean;
  @Input()
    set setUser(u: any) {
      this.user = u;
      this.matchData();
    };

  @Input()
    set isTouch(t: boolean) {
      if (t)
        this.touchSignal();
    }

  public countries!: Country[];
  public provinces!: DataOption[];

  public formResidence = this.formBuilder.group({
    firstname: ['', [Validators.required]],
    lastname: ['', [Validators.required]],

    // Residence
    nationality: ['', [Validators.required]],
    provinceResidence: ['', []],                                                  // Solo ARG
    cityResidence: ['', [Validators.required]],
    addressResidence: ['', [Validators.required]],
    postalCodeResidence: ['', [Validators.required]],
    phoneCourier: ['', [Validators.required]],
  });
  public loading = false;

  constructor(
    private api: ProfileApiService,
    private store: Store<AppState>,
    private formBuilder: UntypedFormBuilder,
    private _t: TranslateService,
  ) { }

  matchData(): void {
    this.countries = getDataCountries();
    this.provinces = getDataProvinces();
    this.formResidence.patchValue(this.user);
    this.onCountryChange();
  }

  onCountryChange(): void {
    setTimeout(() => {
      const country = this.formResidence.get('nationality')?.value;
      if (country == 'AR') {
        this.formResidence.get('provinceResidence')?.setValidators([Validators.required]);
      }
      else {
        this.formResidence.get('provinceResidence')?.clearValidators();
      }
      this.formResidence.get('provinceResidence')?.updateValueAndValidity();
    }, 0);
  }

  submitPersonalData(): void {
    if (this.formResidence.valid) {
      this.loading = true;
      this.api.putUser(this.formResidence.value)
        .subscribe({
          next: res => {
            this.loading = false;
            this.store.dispatch(updateUser({ user: res.result.data }));
            this.dispatchAlertUser();
          }
        });
    }
  }

  dispatchAlertUser(): void {
    this.store.dispatch(emitAlert({
      message: this._t.instant('alert.info_update_ok'),
      alertType: 'success'
    }));
  }

  touchSignal(): void {
    this.formResidence.markAllAsTouched();
  }

}
